import gql from 'graphql-tag'

export const UPDATE_MOVIE_WATCHED =gql`
mutation UpdateMovieWatchedMutation(
  $movieIndex: Int!
)  {
  UpdateMovieWatched(movieIndex: $movieIndex)
} 
`



// WEBPACK FOOTER //
// ./src/mutations/UPDATE_MOVIE_WATCHED.ts